// extracted by mini-css-extract-plugin
export var blockedMessage = "_8n-3";
export var blockedOverlay = "_8n-1";
export var fadeIn = "_8n-2";
export var hereLink = "_8n-0";
export var slideUp = "_8n-4";